// pages/resources/Reports.jsx
export default function Reports() {
  const reports = [
    {
      year: "2026",
      title: "State of Digital Advertising 2026",
      description: "Comprehensive analysis of digital advertising trends, benchmarks, and predictions",
      pages: "85 pages",
      downloads: "12.5K"
    },
    {
      year: "2025",
      title: "Q4 2025 Advertising Performance Report",
      description: "End-of-year insights into campaign performance across industries",
      pages: "52 pages",
      downloads: "8.2K"
    },
    {
      year: "2025",
      title: "E-commerce Advertising Trends 2025",
      description: "Deep dive into e-commerce advertising strategies that drive sales",
      pages: "67 pages",
      downloads: "15.3K"
    },
    {
      year: "2025",
      title: "Social Media ROI Benchmark Report",
      description: "Industry benchmarks for social media advertising ROI and best practices",
      pages: "43 pages",
      downloads: "9.7K"
    },
    {
      year: "2024",
      title: "Mobile Advertising Insights 2024",
      description: "Mobile-first advertising strategies and performance metrics",
      pages: "58 pages",
      downloads: "11.4K"
    },
    {
      year: "2024",
      title: "Video Advertising Performance Study",
      description: "How video ads perform across platforms and industries",
      pages: "48 pages",
      downloads: "7.8K"
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-4">
            Advertising Reports
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            In-depth industry reports packed with data, insights, and actionable strategies
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reports.map((report, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl p-8 hover:border-[#00809D]/50 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#00809D]/20"
            >
              <div className="flex items-start justify-between mb-4">
                <span className="px-4 py-2 bg-[#00809D]/20 text-[#00809D] rounded-xl text-lg font-bold">
                  {report.year}
                </span>
                <div className="flex items-center gap-2 text-gray-400 text-sm">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  {report.downloads}
                </div>
              </div>

              <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-[#00809D] transition-colors">
                {report.title}
              </h3>

              <p className="text-gray-400 mb-6 leading-relaxed">
                {report.description}
              </p>

              <div className="flex items-center justify-between">
                <span className="text-gray-500 text-sm flex items-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  {report.pages}
                </span>
                <button className="bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white px-6 py-2 rounded-xl font-semibold hover:scale-105 transition-all shadow-lg shadow-[#00809D]/50 text-sm">
                  Download PDF
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
